import { IAgent } from "models/Employee/employeeManagement.model";

export const FindAgent = (agents: IAgent[], phoneNumber: string) => {
  return agents?.find((f: IAgent) => f.MobileNo.includes(phoneNumber!));
};
